// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2xK4f","list":"PatternAutocomplete_list__S-UUq"};